import { FC, useState } from "react";
import ExpertiseForm from "./components/ExpertiseForm";
import SearchField from "../managePartners/components/fields/SearchField";
import { DatatableComponent } from "../../helpers/DatatableComponent";
import { useExpertiseAdminTable } from "../../hooks/partners/useExpertiseAdminTable";
import { defaultProfileImage } from "../../utils/constants";
import { ExpertiseListModel } from "../../hooks/partners/models/ExpertiseListModel";
import { DetailExpertiseDrawer } from "./components/DetailExpertiseDrawer";

const ExpertisePage: FC = () => {
  // Orden Armando 2026-09-10: New / Active / Reject — se prioriza ver los aprobados antes que los
  // rechazados porque casi todo el trafico va a ese tab, y Reject se conserva como archivo
  // consultable pero al final.
  const filters: {label: string, value: 'new'|'rejected'|'active'}[] = [
    {label: 'New', value: 'new'},
    {label: 'Active', value: 'active'},
    {label: 'Reject', value: 'rejected'}
  ];

  const [activeTab, setActiveTab] = useState<{label: string, value: 'new'|'rejected'|'active'}>(filters[0]);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const { loading, list, totalPages, reload } = useExpertiseAdminTable(page, activeTab.value, search);
  const [detail, setDetail] = useState<ExpertiseListModel | null>(null);

  return (
    <div className='expertise-page-wrapper'>
      <h3>Expertise</h3>
      
      <div className="expertise-page-wrapper__content">
        <div className='tab-navigation'>
          {(filters).map((tab, index) => (<div key={tab.value} className='d-flex flex-row'>
            <div className={`tab-navigation__item ${activeTab.value === tab.value ? 'tab-navigation__item--selected' : ''}`}
              onClick={()=> setActiveTab(tab)}
            >
              <div className='tab-navigation__label'>{tab.label}</div>
            </div>
            <li className={`separator-vertical ${index < filters.length - 1 ? 'd-flex' : 'd-none'}`}>
              <hr />
            </li>
          </div>))}
        </div>

        <SearchField onChange={setSearch} />
        
        <div className='w-100'>
          <DatatableComponent 
            columns={[
              {
                key: 'id',
                label: 'ID',
                getValue: (row) => <>#{row.id}</>
              },
              {
                key: '',
                label: 'EXPERT',
                getValue: (row) => <div className="partner-author"> <img src={row?.partner?.logo ?? defaultProfileImage} /> <span>{row.partner.companyName}</span></div> 
              },
              {
                key: 'title',
                label: 'TITLE NAME'
              },
              {
                key: 'modalityDisplay',
                label: 'TYPE'
              },
              {
                key: 'rate',
                label: 'PRICE',
                getValue: (row)=> <>${Number(row.rate)}</>,
              },
              // PR-I-87 — columna STATUS con chip para que admin distinga de un vistazo
              // pending/active/rejected sin tener que abrir el drawer. Reusa mismo prefijo de
              // clase que el chip del drawer para estilos consistentes.
              {
                key: 'status',
                label: 'STATUS',
                getValue: (row) => (
                  <span className={`expertise-status-chip expertise-status-chip--${row.status}`}>
                    {row.statusDisplay ?? row.status}
                  </span>
                ),
              }
            ]}
            isLoading={loading}
            tableClassName="expertise-page-wrapper__table"
            data={list}
            onClickRow={setDetail}
            currentPage={page}
            totalPages={totalPages ?? 1}
            onPageChange={setPage}
            textNoWrap
          />
        </div>
        {detail && (
          <DetailExpertiseDrawer
            record={detail}
            show
            onClose={() => setDetail(null)}
            onModerated={reload}
          />
        )}
      </div>
    </div>
  )
}

export { ExpertisePage }    